import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { renderMarkdown } from 'common/utils/helpers';

function ResultsSummaryIntroduction(props) {
  const { introduction, multiPagesDisplay } = props;

  if (!introduction) return null;

  return (
    <div className={classNames('results-summary-introduction', { 'no-border': multiPagesDisplay })}>
      <div
        className="markdown"
        dangerouslySetInnerHTML={{ __html: renderMarkdown(introduction) }}
      />
    </div>
  );
}

ResultsSummaryIntroduction.propTypes = {
  introduction: PropTypes.string,
  multiPagesDisplay: PropTypes.bool,
};

ResultsSummaryIntroduction.defaultProps = {
  introduction: undefined,
  multiPagesDisplay: false,
};

export default ResultsSummaryIntroduction;
